import classNames from 'classnames'
import { FC } from 'react'

interface Props {
	className?: string
}

const LoadingSpinner: FC<Props> = ({ className }) => {
	return (
		<div className={classNames('loading-spinner', className)}>
			<div className="ellipse"></div>
		</div>
	)
}

export default LoadingSpinner
